import {i18n} from '@lingui/core';
import {t} from '@lingui/macro';

const notFoundError = i18n._(t('rule-dryrun-error-notfound')`Event not found.`);
const forbiddenError = i18n._(t('rule-dryrun-error-forbidden')`You do not have access to this event.`);
const unknownError = i18n._(t('rule-dryrun-error-unknown')`Error while evaluating variables.`);

const codeErrors: Record<string, string> = {
  bad_id: i18n._(t('rule-dryrun-error-format')`Not a valid Front ID.`),
  bad_namespace_team: i18n._(t('rule-dryrun-error-namespace-team')`Conversation must appear in the team.`),
  bad_namespace_teammate: i18n._(
    t('rule-dryrun-error-namespace-teammate')`Conversation must appear in the rule owner's inbox.`,
  ),
  conversation_activity: i18n._(
    t('rule-dryrun-error-convactivity')`No event in this conversation matching your triggers.`,
  ),
};

export function parseRuleDryRunError(err: any): string {
  const {body} = err;
  if (!body) {
    return unknownError;
  }

  const codeError = codeErrors[body.code];
  if (codeError) {
    return codeError;
  }

  if (body.status === 'not_found') {
    return notFoundError;
  }

  if (body.status === 'forbidden') {
    return forbiddenError;
  }

  return unknownError;
}
